import { TextInputField } from "@sainsburys-tech/luna-form";
import { Form } from "@sainsburys-tech/luna-form";
import { Container, GridItem, GridWrapper } from "@sainsburys-tech/luna-grid";
import { FC, useEffect, useState } from "react";
import {
  FIELDS,
  FormInputLevels
} from "../../../Interfaces/Product/IProductFormField";
import { ProductFormProps } from "../../../Types/Product/ProductFormProps";
import ActionButton from "../../SharedComponents/ActionButton";
import FamilyGroupAutoComplete from "../../SharedComponents/FamilyGroupAutoComplete";
import { useSelector } from "react-redux";
import { SelectField } from "@sainsburys-tech/luna-form";
import { UI_CONSTANTS } from "../../../Constants/constants";

const MeasurementsClothingForm: FC<ProductFormProps> = (props) => {
  const [isFormDirty, setIsFormDirty] = useState<boolean | undefined>(
    props.dirty || true
  );
  const pageDirtyPayload = useSelector((state: any) => state.pageDirtyReducer);

  useEffect(() => {
    if (pageDirtyPayload.data !== null) {
      let compareResult =
        JSON.stringify(pageDirtyPayload.data.values) ===
        JSON.stringify(props.values);
      setIsFormDirty(compareResult);
    }
  }, [pageDirtyPayload]);

  return (
    <>
      <Container>
        <Form className="o-form">
          <GridWrapper className="ln-u-push-bottom">
            <GridItem size={{ sm: "1/4", xs: "1" }}>
              <TextInputField
                name={FIELDS.sainId.name}
                label={FormInputLevels.SainId}
                maxLength={128}
                value={props.values.sainId}
                error={props.errors?.sainId}
                onBlur={props.onBlur}
                onChange={props.onChange}
                required
                disabled={true}
              />
            </GridItem>
            <GridItem size={{ sm: "1/4", xs: "1" }}>
              <TextInputField
                name="displayItemNumber"
                label={FormInputLevels.DisplayItemNumber}
                value={
                  props.values.skuNumber
                    ? props.values.skuNumber
                    : props.values.catNumber
                }
                disabled={true}
              />
            </GridItem>
            <GridItem size={{ sm: "1/4", xs: "1" }}>
              <FamilyGroupAutoComplete
                productType={props.values.productType}
                className="hide-arrow"
                label="Family Group"
                name="FamilyGroupNew"
                placeholder="Please select"
                testid="autocomplete-field"
                initialValue={props.values.familyGroup || ""}
                onSelect={(e: any) => {
                  if (e === null || e?.value === null) {
                    e = {
                      label: props.values.familyGroup,
                      value: { desc: props.values.familyGroup },
                    };
                  }
                  props.onChange(e, e.label, e.value?.desc, false);
                }}
              />
            </GridItem>
          </GridWrapper>
          <GridWrapper className="ln-u-push-bottom">
            <GridItem size={{ sm: "1/4", xs: "1" }}>
              <TextInputField
                name={FIELDS.productType.name}
                label={FormInputLevels.ProductType}
                value={props.values.productType}
                disabled={true}
              />
            </GridItem>
            <GridItem size={{ sm: "1/4", xs: "1" }}>
              <TextInputField
                name={FIELDS.packSize.name}
                label={FormInputLevels.PackSize}
                value={
                  props.values.alias === UI_CONSTANTS.SAINSBURYS_SKU ||
                  props.values.alias === UI_CONSTANTS.SAINSBURYS_PACK
                    ? `CS${props.values.packSize}`
                    : props.values.alias === UI_CONSTANTS.ARGOS
                    ? `EA`
                    : props.values.packSize
                }
                disabled={true}
              />
            </GridItem>
          </GridWrapper>

          <GridWrapper className="ln-u-push-bottom">
            <GridItem size={{ sm: "1/4", xs: "1" }}>
              <TextInputField
                name={FIELDS.ti.name}
                label={FormInputLevels.InnerTi}
                maxLength={128}
                value={props.values.ti}
                error={props.errors?.ti}
                onBlur={props.onBlur}
                onChange={props.onChange}
                required
              />
            </GridItem>
            <GridItem size={{ sm: "1/4", xs: "1" }}>
              <TextInputField
                name={FIELDS.hi.name}
                label={FormInputLevels.InnerHi}
                maxLength={128}
                value={props.values.hi}
                error={props.errors?.hi}
                onBlur={props.onBlur}
                onChange={props.onChange}
                required
              />
            </GridItem>
            <GridItem size={{ sm: "1/4", xs: "1" }}>
              <TextInputField
                name={FIELDS.breakPack.name}
                label={FormInputLevels.BreakPack}
                maxLength={128}
                value={props.values.breakPack}
                error={props.errors?.breakPack}
                onBlur={props.onBlur}
                onChange={props.onChange}
                required
              />
            </GridItem>
            <GridItem size={{ sm: "1/4", xs: "1" }}>
              <TextInputField
                name={FIELDS.innerHeight.name}
                label={FormInputLevels.InnerHeight}
                maxLength={128}
                value={props.values.innerHeight}
                error={props.errors?.innerHeight}
                onBlur={props.onBlur}
                onChange={props.onChange}
                required
              />
            </GridItem>
          </GridWrapper>
          <GridWrapper className="ln-u-push-bottom">
            <GridItem size={{ sm: "1/4", xs: "1" }}>
              <TextInputField
                name={FIELDS.innerLength.name}
                label={FormInputLevels.InnerLength}
                maxLength={128}
                value={props.values.innerLength}
                error={props.errors?.innerLength}
                onBlur={props.onBlur}
                onChange={props.onChange}
                required
              />
            </GridItem>
            <GridItem size={{ sm: "1/4", xs: "1" }}>
              <TextInputField
                name={FIELDS.innerWeight.name}
                label={FormInputLevels.InnerWeight}
                maxLength={128}
                value={props.values.innerWeight}
                error={props.errors?.innerWeight}
                onBlur={props.onBlur}
                onChange={props.onChange}
                required
              />
            </GridItem>
            <GridItem size={{ sm: "1/4", xs: "1" }}>
              <TextInputField
                name={FIELDS.innerWidth.name}
                label={FormInputLevels.InnerWidth}
                maxLength={128}
                value={props.values.innerWidth}
                error={props.errors?.innerWidth}
                onBlur={props.onBlur}
                onChange={props.onChange}
                required
              />
            </GridItem>
            <GridItem size={{ sm: "1/4", xs: "1" }}>
              <TextInputField
                name={FIELDS.innerNetWeight.name}
                label={FormInputLevels.InnerNetWeight}
                maxLength={128}
                value={props.values.innerNetWeight}
                error={props.errors?.innerNetWeight}
                onBlur={props.onBlur}
                onChange={props.onChange}
                required
              />
            </GridItem>
          </GridWrapper>
          <GridWrapper className="ln-u-push-bottom">
            <GridItem size={{ sm: "1/4", xs: "1" }}>
              <TextInputField
                name={FIELDS.outerLength.name}
                label={FormInputLevels.OuterLength}
                maxLength={128}
                value={props.values.outerLength}
                error={props.errors?.outerLength}
                onBlur={props.onBlur}
                onChange={props.onChange}
                required
              />
            </GridItem>
            <GridItem size={{ sm: "1/4", xs: "1" }}>
              <TextInputField
                name={FIELDS.outerHeight.name}
                label={FormInputLevels.OuterHeight}
                maxLength={128}
                value={props.values.outerHeight}
                error={props.errors?.outerHeight}
                onBlur={props.onBlur}
                onChange={props.onChange}
                required
              />
            </GridItem>
            <GridItem size={{ sm: "1/4", xs: "1" }}>
              <TextInputField
                name={FIELDS.outerWeight.name}
                label={FormInputLevels.OuterWeight}
                maxLength={128}
                value={props.values.outerWeight}
                error={props.errors?.outerWeight}
                onBlur={props.onBlur}
                onChange={props.onChange}
                required
              />
            </GridItem>
            <GridItem size={{ sm: "1/4", xs: "1" }}>
              <TextInputField
                name={FIELDS.outerLength.name}
                label={FormInputLevels.OuterWidth}
                maxLength={128}
                value={props.values.outerWidth}
                error={props.errors?.outerWidth}
                onBlur={props.onBlur}
                onChange={props.onChange}
                required
              />
            </GridItem>
          </GridWrapper>

          <GridWrapper className="ln-u-push-bottom">
            <GridItem size={{ sm: "1/4", xs: "1" }}>
              <TextInputField
                name={FIELDS.outerNetWeight.name}
                label={FormInputLevels.OuterNetWeight}
                maxLength={128}
                value={props.values.outerNetWeight}
                error={props.errors?.outerNetWeight}
                onBlur={props.onBlur}
                onChange={props.onChange}
                required
              />
            </GridItem>
            <GridItem size={{ sm: "1/4", xs: "1" }}>
              <TextInputField
                name={FIELDS.grabInBox.name}
                label={FormInputLevels.GrabInBox}
                maxLength={128}
                value={props.values.grabInBox}
                error={props.errors?.grabInBox}
                onBlur={props.onBlur}
                onChange={props.onChange}
                required
              />
            </GridItem>
          </GridWrapper>
        </Form>
        <ActionButton
          onSubmit={props.onSubmit}
          onClearAll={props.onClearAll}
          onCancel={props.onCancel}
          isAddDisabled={isFormDirty}
          isDirty={props.dirty}
          isEdit={props.isEdit}
          isClearButtonRequired={false}
          submitted={props.submitted}
        />
      </Container>
    </>
  );
};

export default MeasurementsClothingForm;
